import { render, staticRenderFns } from "./lrEditor.vue?vue&type=template&id=1f5c4e9c"
import script from "./lrEditor.vue?vue&type=script&lang=js"
export * from "./lrEditor.vue?vue&type=script&lang=js"
import style0 from "./lrEditor.vue?vue&type=style&index=0&id=1f5c4e9c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports